import { Component, OnInit, ViewChild } from '@angular/core';
import { ListadoPersonasComponent } from './listado-personas/listado-personas.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ImportarDialog } from './dialog-importar/importar-dialog.component';

@Component({
  selector: 'app-personas',
  templateUrl: './personas.component.html',
  styleUrls: ['./personas.component.scss']
})
export class PersonasComponent implements OnInit {
  sidenavWidth: any;
  @ViewChild('listado') listado: ListadoPersonasComponent;
  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
  }
  increase() {
    this.sidenavWidth = 15;
  }
  decrease() {
    this.sidenavWidth = 5;
  }

  importarProspectos(){
    let dialogImportar = this.dialog.open(ImportarDialog, {
      disableClose: true,
      data:{
        "tipo": "dato"
      }
    });

    dialogImportar.afterClosed().subscribe(flujoCreado => {
      this.actualizarListado();
    });
  }

  actualizarListado() {
    this.listado.actualizarTabla();
  }
}
